import React from "react";

export function ErrorMessage({ className = '', children }) {

  return (
    <div className={`p-4 rounded mb-2 bg-apricot-dark w-full max-w-none shadow-sm flex justify-between ${className}`}>
      <div>
        {children}
      </div>
    </div>
  );
}
